import Vue from 'vue';
import VueI18n from 'vue-i18n';
// Languages
import ar from './ar';
import en from './en';
import { getDirectionMeta } from '@/utils/global';

Vue.use(VueI18n);

const messages = { ar, en };

const i18n = new VueI18n({
  locale: getDirectionMeta().language,
  messages,
});

export default i18n;
